import BusinessCard from "./BusinessCard";

const BusinessList = ({ businesses }) => {
  return (
    <div className="pb-8 w-full">
      <div>
        <div>
          {businesses?.length > 0 ? (
            businesses.map((business, index) => {
              return <BusinessCard business={business} />;
            })
          ) : (
            <div className="flex flex-col items-center justify-start h-full w-full text-center p-6  shadow-inner">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="50"
                height="50"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-circle-off-icon lucide-circle-off"
              >
                <path d="m2 2 20 20" />
                <path d="M8.35 2.69A10 10 0 0 1 21.3 15.65" />
                <path d="M19.08 19.08A10 10 0 1 1 4.92 4.92" />
              </svg>

              <h2 className="text-xl font-semibold text-gray-600">
                No Businesses Found
              </h2>
              <p className="text-gray-500 mt-2 max-w-sm">
                We couldn't find any businesses to show right now. Please check
                back later or try a different filter.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BusinessList;
